import styled from 'styled-components';

export const Button = styled.button`
  width: 100%;
  min-height: 48px;
  padding: 12px 24px;
  background: ${({ theme, variant }) =>
        variant === 'secondary' ? 'transparent' : theme.colors.primary.main};
  color: ${({ theme, variant }) =>
        variant === 'secondary' ? theme.colors.primary.main : '#fff'};
  border: ${({ theme, variant }) =>
        variant === 'secondary' ? `2px solid ${theme.colors.primary.main}` : 'none'};
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;

  &:hover:not(:disabled) {
    background: ${({ theme, variant }) =>
        variant === 'secondary' ? theme.colors.primary.main : theme.colors.primary.light};
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(59, 89, 152, 0.2);
  }

  &:active:not(:disabled) {
    background: ${({ theme }) => theme.colors.primary.dark};
    transform: translateY(0);
  }
  
  &:disabled {
    background: ${({ theme }) => theme.colors.gray[200]};
    cursor: not-allowed;
    border: none;
    color: #fff;
    opacity: 0.6;
  }
`;
